import apiClient from '../config/api';

const notificationService = {
  /** Paginated notifications */
  getNotifications: async ({ page = 1, pageSize = 20, type = null, isRead = null } = {}) => {
    const params = { page, pageSize };
    if (type) params.type = type;
    if (isRead !== null) params.isRead = isRead;
    const response = await apiClient.get('/notifications', { params });
    return response.data;
  },

  /** Get unread notification count */
  getUnreadCount: async () => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data; // Expected: { count: number }
  },

  /** Mark a single notification as read */
  markAsRead: async (id) => {
    const response = await apiClient.post(`/notifications/${id}/read`);
    return response.data;
  },

  /** Mark all notifications as read */
  markAllAsRead: async () => {
    const response = await apiClient.post('/notifications/read-all');
    return response.data;
  },

  /** Delete a notification */
  deleteNotification: async (id) => {
    const response = await apiClient.post(`/notifications/${id}/delete`);
    return response.data;
  },
};

export default notificationService;
